<template>
	<v-app>
		<div class="wrap" :class="[detailStore.isDark ? 'darkmode' : '']">
			<headerLayout @click:mode-chg="mode"></headerLayout>
			<div class="container">
				<leftMenuLayout></leftMenuLayout>
				<div class="content pump">
					<NuxtPage/>
				</div>
			</div>
		</div>
	</v-app>
</template>

<script setup lang="ts">
import {watch, onMounted} from 'vue'
import headerLayout from '~/components/header.vue'
import leftMenuLayout from '~/components/leftMenu2.vue'
import {useDetailStore} from '~/stores/detail'
import {useTheme} from 'vuetify'

const detailStore = useDetailStore()
const theme = useTheme()

// mode toggle 처리
const mode = (e: { value: boolean }) => {
	const isDark = !e.value
	detailStore.setIsDark(isDark)
	theme.global.name.value = isDark ? 'dark' : 'light'
	document.querySelector('.wrap')?.classList.toggle('darkmode', isDark)
}

// 초기 mount 시 적용
onMounted(() => {
	const isDark = detailStore.isDark
	theme.global.name.value = isDark ? 'dark' : 'light'
	document.querySelector('.wrap')?.classList.toggle('darkmode', isDark)
})

// sessionStorage에 저장
watch(() => detailStore.isDark, (newVal) => {
	sessionStorage.setItem('isDark', newVal.toString())
})
</script>

<style lang="scss" scoped>
</style>